import { Item } from "../model/Item";

export function getItem(itemId: number): Promise<Item> {
    return fetch(`https://hacker-news.firebaseio.com/v0/item/${itemId}.json`)
        .then(resp => {
            if (!resp.ok) {
                return null;
            }
            return resp.json();
        })
        .catch(() => {
            return null;
        });
}
